import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <Section tone="white" data-id="element-92" data-mp="1clpjan0xo2ti">
      <SectionHeading kicker="5 exclusive bonuses — free today" data-id="element-93" data-mp="1citlcyp35e52">
        Valued at <span className="text-berry" data-id="element-94" data-mp="18lfg1i4izqic">$197</span> — included free with your $27 order
      </SectionHeading>

      <div className="mt-12 space-y-14" data-id="element-95" data-mp="25925ux73gamt">
        {bonuses.map(b => <article key={b.number} data-id="element-96" data-mp="20c20koi2jbwr">
            <div className="-mx-4 sm:mx-0" data-id="element-97" data-mp="208xpr8a3lhx4">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full bg-cream sm:rounded-3xl" loading="lazy" data-id="element-98" data-mp="1w8dte6xcmic1" />
            </div>
            <div className="mt-5" data-id="element-99" data-mp="kvl2szganzxk">
              <div className="flex flex-wrap items-center gap-2" data-id="element-100" data-mp="fux2fn66e6qo">
                <span className="flex items-center gap-1.5 rounded-full bg-berry px-3 py-1 text-[12px] font-bold uppercase tracking-wider text-white" data-id="element-101" data-mp="ftlztqogv515">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-102" data-mp="1jt9pmkxf8xx6" />
                  Bonus #{b.number}
                </span>
                <span className="text-[14px] font-semibold text-muted" data-id="element-103" data-mp="15s71m2mv9djm">
                  Value: <s data-id="element-104" data-mp="1ara69lyxphr2">${b.value}</s> <strong className="text-cta" data-id="element-105" data-mp="1aqqmdzpq4jae">FREE today</strong>
                </span>
              </div>
              <h3 className="mt-3 font-serif text-[26px] font-bold leading-tight text-ink md:text-3xl" data-id="element-106" data-mp="w1m5qmykun4e">{b.title}</h3>
              <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-107" data-mp="10vyqr1fpc6i9">{b.text}</p>
              {b.list.length > 0 && <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-108" data-mp="r42hqvc2uvz9">
                  {b.list.map(item => <li key={item} className="flex items-start gap-2.5 text-[16px] text-ink" data-id="element-109" data-mp="d4kuwlicdssj">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-110" data-mp="i34jyus8fkp4" />
                      {item}
                    </li>)}
                </ul>}
            </div>
          </article>)}
      </div>

      <CTAButton label="I want all 5 bonuses free" data-id="element-111" data-mp="2f00i7lb4mmdl" />
    </Section>;
}